import AdvertisingImportForm from './AdvertisingImportForm';

export default AdvertisingImportForm;
